export default {
  modulesList: [],
};
